import { createSelector } from 'reselect'

/**
 * Select the location state slice
 * @param {object} state - Redux state
 * @returns {object} Location state
 */
export const selectLocation = (state) => state.location

/**
 * Select the current geolocation
 * @param {object} state - Redux state
 * @returns {object|null} Current location coordinates
 */
export const selectCurrentLocation = createSelector(
  selectLocation,
  (location) => location.currentLocation
)

/**
 * Select whether the app is running in Electron
 * @param {object} state - Redux state
 * @returns {boolean|null} Electron status
 */
export const selectIsElectron = createSelector(
  selectLocation,
  (location) => location.isElectron
)

/**
 * Select the Electron locale
 * @param {object} state - Redux state
 * @returns {string|null} Electron locale
 */
export const selectElectronLocale = createSelector(
  selectLocation,
  (location) => location.electronLocale
)

/**
 * Select the Electron OS user
 * @param {object} state - Redux state
 * @returns {string|null} Electron OS user
 */
export const selectElectronOSUser = createSelector(
  selectLocation,
  (location) => location.electronOSUser
)

/**
 * Select the location permission status
 * @param {object} state - Redux state
 * @returns {string|null} Permission status
 */
export const selectLocationPermissionStatus = createSelector(
  selectLocation,
  (location) => location.permissionStatus
)
